import script from "./FieldSort.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldSort.vue?vue&type=script&setup=true&lang=js"

import "./FieldSort.vue?vue&type=style&index=0&id=6152becc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6152becc"]])

export default __exports__